module.exports = __webpack_public_path__ + "static/media/twsArticle.4d632302.png";